var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"main-footer"},[_c('strong',[_vm._v("Copyright © "+_vm._s(new Date().getFullYear())+" "),_c('a',{attrs:{"href":"https://agencialink.com"}},[_vm._v("AgenciaLink.com")]),_vm._v(".")])])
}
var staticRenderFns = []

export { render, staticRenderFns }